import { memo } from 'react';
import { Link } from '@/hen-ui/atomics/Link';
import { List, ListItem } from '@/hen-ui/atomics/List';
import { cn } from '@/hen-ui/utils';
import type { NavItem, SubNavLinkHover } from './types';
import { ColumnLabel } from './ColumnLabel';
import { resolveNavLinkProps } from './subnav.constants';
import { hasValidHref } from './utils';

interface ThirdColumnProps {
  column: NavItem;
  linkHover?: SubNavLinkHover;
}

export const ThirdColumn = memo(function ThirdColumn({
  column,
  linkHover,
}: ThirdColumnProps) {
  const links = (column.children ?? []).filter(
    (child) => child.type !== 'action' || hasValidHref(child),
  );

  return (
    <div className='relative mt-lg flex w-full flex-col border-t border-neutral-200 pt-lg lg:mt-sm lg:pt-sm xl:mt-0 xl:w-1/3 xl:border-t-0 xl:pl-lg xl:pt-0 xl:before:absolute xl:before:left-0 xl:before:top-0 xl:before:h-full xl:before:w-px xl:before:bg-neutral-200'>
      <ColumnLabel item={column} variant='prominent' />
      {links.length > 0 && (
        <List
          bulletStyle='none'
          className='gap-lg pt-xl text-b4 lg:gap-xs lg:pt-sm lg:text-b5 xl:gap-xs xl:pt-lg xl:text-b4'
        >
          {links.map((link) => {
            const props = resolveNavLinkProps(link, 'black', linkHover);
            return (
              <ListItem
                key={link.id}
                className='text-[length:inherit] leading-[inherit]'
              >
                {hasValidHref(link) ? (
                  <Link
                    href={link.uri}
                    variant={props.variant}
                    size={props.size}
                    underline='none'
                    underlineStyle='thin'
                    className={cn(
                      props.className,
                      'text-[length:inherit] leading-[inherit]',
                    )}
                  >
                    {link.label}
                  </Link>
                ) : (
                  <span className='text-black text-[length:inherit] leading-[inherit]'>
                    {link.label}
                  </span>
                )}
              </ListItem>
            );
          })}
        </List>
      )}
    </div>
  );
});
